module.exports = __webpack_public_path__ + "static/media/Rubik-Medium.c87313aa.ttf";